// extracted by mini-css-extract-plugin
export default {"root":"SystemMsgDetail_root__I8fKd","title":"SystemMsgDetail_title__jfrxU","time":"SystemMsgDetail_time__M6mUU","content":"SystemMsgDetail_content__iK1fL"};